import { Box, Icon, makeUclComponent } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import ActionButton, { ActionButtonVariants } from 'components/action-button';

export const ErrorIcon = Icon.withConfig({
  name: 'mi:error',
  size: '$9',
});

export const DialogIconContainer = Box.withConfig({
  alignItems: 'center',
});

export const DialogTitle = withTypography({
  variant: 'headerTwo',
  fontSize: '2xl',
  textAlign: 'center',
  mt: '$3',
  lineHeight: 'lg',
});

export const DialogContent = withTypography({
  variant: 'copyOne',
  fontSize: 'md',
  textAlign: 'center',
  my: '$3',
});

export const ConfirmButton = makeUclComponent(ActionButton).withConfig({
  fullWidth: true,
  variant: ActionButtonVariants.PRIMARY,
  marginBottom: '$3',
});

export const CloseButton = makeUclComponent(ActionButton).withConfig({
  fullWidth: true,
  variant: ActionButtonVariants.TEXT_ONLY,
});

export const ModalActionsContainer = Box.withConfig({
  width: '100%',
});
